// crm namespace — CRM Dashboard: Today zone, first-run setup, setup banner.
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "dash.openingClient": "Ouverture de la fiche client…",
    "dash.title": "Tableau de bord CRM",
    "setup.addBody": "Ouvre le panneau latéral",
    "setup.addTitle": "Ajoutez un premier client",
    "setup.bannerReminders": "Rappels",
    "setup.bannerText": "Vos séquences de bienvenue et de rappel sont prêtes, rédigées pour vous. Relisez-les et activez-les.",
    "setup.bannerWelcome": "Bienvenue",
    "setup.done": "Fait",
    "setup.importBody": "Ouvre l'assistant",
    "setup.importTitle": "Importez vos clients",
    "setup.remindersBody": "Un seul geste, le gain le plus rapide",
    "setup.remindersOn": "Les rappels de séance sont activés",
    "setup.remindersOwnerOnly": "Seul le titulaire du cabinet peut activer les rappels.",
    "setup.remindersTitle": "Activez les rappels",
    "setup.title": "Configurons votre CRM",
    "today.attendees": "{n} participants",
    "today.completed": "Terminée",
    "today.confirmed": "Confirmé depuis le rappel",
    "today.count": "{day} · {n} séances",
    "today.empty": "Aucune séance aujourd'hui",
    "today.markComplete": "Marquer terminée",
    "today.new": "Nouveau",
    "today.noShow": "Absence",
    "today.noShowDone": "Absence notée",
    "today.noteLater": "Plus tard",
    "today.notePromptBody": "Quelques lignes pour la prochaine fois avec {name}. Vous seul pouvez la lire.",
    "today.notePromptTitle": "Ajouter une note de séance ?",
    "today.openAria": "Ouvrir {name}, {time}",
    "today.reminderSent": "Rappel renvoyé",
    "today.resendAria": "Pas encore confirmé — renvoyer le rappel",
    "today.sessionOf": "Séance {n} sur {total}",
    "today.tapToResend": "Touchez ? pour renvoyer le rappel",
    "today.title": "Aujourd'hui",
    "today.remindersOff": "Activez d'abord les rappels",
  },
  en: {
    "dash.openingClient": "Opening the client record…",
    "dash.title": "CRM Dashboard",
    "setup.addBody": "Opens the slide-over",
    "setup.addTitle": "Add first client",
    "setup.bannerReminders": "Reminders",
    "setup.bannerText": "Your Welcome and Reminder sequences are ready, written for you. Review and switch on.",
    "setup.bannerWelcome": "Welcome",
    "setup.done": "Done",
    "setup.importBody": "Opens the wizard",
    "setup.importTitle": "Import your clients",
    "setup.remindersBody": "One tap, the fastest win",
    "setup.remindersOn": "Session reminders are on",
    "setup.remindersOwnerOnly": "Only the practice owner can turn on reminders.",
    "setup.remindersTitle": "Turn on reminders",
    "setup.title": "Let's get you set up",
    "today.attendees": "{n} attendees",
    "today.completed": "Completed",
    "today.confirmed": "Confirmed from the reminder",
    "today.count": "{day} · {n} sessions",
    "today.empty": "No sessions today",
    "today.markComplete": "Mark complete",
    "today.new": "New",
    "today.noShow": "No-show",
    "today.noShowDone": "Marked as no-show",
    "today.noteLater": "Later",
    "today.notePromptBody": "A few lines for next time with {name}. Only you can read it.",
    "today.notePromptTitle": "Add a session note?",
    "today.openAria": "Open {name}, {time}",
    "today.reminderSent": "Reminder sent again",
    "today.resendAria": "Not confirmed yet — resend the reminder",
    "today.sessionOf": "Session {n} of {total}",
    "today.tapToResend": "Tap ? to resend the reminder",
    "today.title": "Today",
    "today.remindersOff": "Turn on reminders first",
  },
  es: {
    "dash.openingClient": "Abriendo la ficha del cliente…",
    "dash.title": "Panel del CRM",
    "setup.addBody": "Abre el panel lateral",
    "setup.addTitle": "Añade tu primer cliente",
    "setup.bannerReminders": "Recordatorios",
    "setup.bannerText": "Tus secuencias de bienvenida y de recordatorio están listas, redactadas para ti. Revísalas y actívalas.",
    "setup.bannerWelcome": "Bienvenida",
    "setup.done": "Hecho",
    "setup.importBody": "Abre el asistente",
    "setup.importTitle": "Importa tus clientes",
    "setup.remindersBody": "Un toque, la mejora más rápida",
    "setup.remindersOn": "Los recordatorios de sesión están activados",
    "setup.remindersOwnerOnly": "Solo la persona titular puede activar los recordatorios.",
    "setup.remindersTitle": "Activa los recordatorios",
    "setup.title": "Vamos a configurarlo",
    "today.attendees": "{n} asistentes",
    "today.completed": "Completada",
    "today.confirmed": "Confirmado desde el recordatorio",
    "today.count": "{day} · {n} sesiones",
    "today.empty": "No hay sesiones hoy",
    "today.markComplete": "Marcar completada",
    "today.new": "Nuevo",
    "today.noShow": "No se presentó",
    "today.noShowDone": "Marcada como ausencia",
    "today.noteLater": "Más tarde",
    "today.notePromptBody": "Unas líneas para la próxima vez con {name}. Solo tú puedes leerla.",
    "today.notePromptTitle": "¿Añadir una nota de sesión?",
    "today.openAria": "Abrir {name}, {time}",
    "today.reminderSent": "Recordatorio reenviado",
    "today.resendAria": "Aún sin confirmar: reenviar el recordatorio",
    "today.sessionOf": "Sesión {n} de {total}",
    "today.tapToResend": "Toca ? para reenviar el recordatorio",
    "today.title": "Hoy",
    "today.remindersOff": "Activa primero los recordatorios",
  },
};
